import MultiFilterPanel from './MultiFilterPanel.component';

export default MultiFilterPanel;
